import gql from 'graphql-tag';
export default gql`
  mutation(
    $input: FinalizeUploadArtworkInput!
    $uploadID: ID!
    $customName: String
  ) {
    finalizeUploadArtwork(
      input: $input
      uploadID: $uploadID
      customName: $customName
    ) {
      id
      artworkID
      ArtworkArtifact {
        SignedUrl {
          action
          expires
          url
          name
          seconds
        }
      }
    }
  }
`;
